module.exports = __webpack_public_path__ + "static/media/plus.cc856f17.svg";